import React, { useState } from 'react';

import Footer from '../../components/Footer';

import Contact from '../../components/Contact';

const Contactpage = () => {

  // const [loading, setLoading] = useState(false);

  // const [formData, setFormData] = useState({
  //   name: '',
  //   contactNumber: '',
  //   email: '',
  //   city: '',
  //   purpose: '',
  //   message: '',
  // });

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //    setLoading(true); // disable the button

  //   try {
  //     const response = await axios.post('/api/contact', formData);
  //     // console.log('New contact saved:', newContact);  // Debugging log
  //     alert('Form submitted successfully!');
  //     setFormData({
  //       name: '',
  //       contactNumber: '',
  //       email: '',
  //       city: '',
  //       purpose: '',
  //       message: '',
  //     });  // Reset form after submission
  //   } catch (error) {
  //     console.error('Error submitting the form', error);
  //     alert('Error submitting the form. Please try again.');
  //   }
  //   finally {
  //   setLoading(false); // re-enable the button
  // }
  // };

 return (
  <>
    <Contact />
    <Footer/>
    </>
  );
};

export default Contactpage;

